// extracted by mini-css-extract-plugin
export var container = "_dx-0";
export var icon = "_dx-1";
export var text = "_dx-2";